import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { CONSENT_CHANGE_EVENT, consentAllows } from '../consent/consentStore';

function suppressed(pathname) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return true;
  if (!consentAllows('analytics')) return true;
  if (window.__onJoinPage || window.__joinCodeInUrl) return true;
  if (pathname === '/join' || pathname.indexOf('/join/') === 0) return true;
  return false;
}

/**
 * One page view per pathname, and only with Analytics consent. The base gtag
 * config sets send_page_view false, so this sends an event rather than another
 * config call. A path counts as sent only when a view was really sent, and the
 * view for the page the visitor consented on is sent when consent is given.
 */
export default function PageView() {
  const location = useLocation();
  const sentPath = useRef(null);
  const pathRef = useRef(location.pathname);
  pathRef.current = location.pathname;

  const sendFor = (pathname) => {
    if (sentPath.current === pathname) return;
    if (suppressed(pathname)) return;
    sentPath.current = pathname;
    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
    });
  };

  useEffect(() => {
    sendFor(location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    const onConsent = () => sendFor(pathRef.current);
    window.addEventListener(CONSENT_CHANGE_EVENT, onConsent);
    return () => window.removeEventListener(CONSENT_CHANGE_EVENT, onConsent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
